<template>
    <div :class="{'trend-search-group-wrap': true, 'detail': readOnlyStatus }">
        <div class="trend-search-group-title">
<!--            条件组{{index}} 移除或逻辑注释-->
            条件组
            <div v-if="!readOnlyStatus" class="trend-search-group-title-btn">
                <span @click="addClause"><i class="el-icon-plus" />添加条件</span>
                <slot></slot>
            </div>
        </div>
        <div class="trend-search-group-header">
            <span style="padding-left: 12px;">字段</span>
            <span>计算</span>
            <span>值</span>
            <span v-if="!readOnlyStatus" class="trend-search-group-header-ctrl">操作</span>
        </div>
        <trend-search-item v-for="(clause, i) in clauseArray" :key="clause.id || clause.labelQueryId" :clause="clause"><span v-if="clauseArray.length > 1" @click="delClause(i)" class="trend-search-group-del">删除</span></trend-search-item>
    </div>
</template>

<script>
    import TrendSearchItem from "./TrendSearchItem";
    export default {
        name: "TrendSearchGroup",
        inject:['readOnly'],
        props: {
            group: {
                type: Array
            },
            index: {
                type: Number
            }
        },
        components: {
            TrendSearchItem
        },
        data() {
            return {
                clauseArray: []
            }
        },
        created() {
            this.clauseArray = this.group
        },
        computed: {
            readOnlyStatus () {
                return this.readOnly()
            }
        },
        methods: {
            addClause () {
                this.clauseArray.push({
                    id: Date.now(),
                    fieldDicKey: "",
                    fieldDicKeyInputFormat: "",
                    fieldInputType: "",
                    fieldName: "",
                    queryField: "",
                    fieldCondKey: "",
                    fieldValue: "",
                    queryGroup: "",
                    fieldGroup: "",
                    querySql: ""
                })
            },
            delClause (i) {
                this.clauseArray.splice(i, 1)
            }
        }
    }
</script>

<style lang="scss">
    .trend-search-group-wrap {
        border-radius: 8px;
        border: 1px dashed #E2E2E8;
        padding: 12px 16px 16px;
        margin-bottom: 16px;
        box-sizing: border-box;
        &.detail {
            border-style: solid;
        }
        .trend-search-group-title {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 12px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: #15181E;
            line-height: 18px;
            margin-bottom: 8px;
            .trend-search-group-title-btn {
                > span {
                    font-size: 12px;
                    font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                    font-weight: normal;
                    color: rgba(230, 65, 23, 1);
                    line-height: 18px;
                    cursor: pointer;
                    i {
                        margin-right: 5px;
                    }
                    + span {
                        margin-left: 10px;
                    }
                }
            }
        }
        .trend-search-group-header {
            display: flex;
            justify-content: space-around;
            padding: 8px 0;
            background: #F5F7FA;
            border-radius: 4px;
            > span {
                width: 30%;
                font-size: 14px;
                font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
                font-weight: normal;
                color: rgba(21,24,30,0.75);
                line-height: 20px;
            }
            .trend-search-group-header-ctrl {
                width: 10%;
            }
        }
        .trend-search-group-del {
            font-size: 14px;
            font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
            font-weight: normal;
            color: rgba(230, 65, 23, 1);
            line-height: 20px;
            cursor: pointer;
        }
    }
</style>
